<template>
  <v-card
    flat
    width="100%"
    class="send-code">
    <v-card-text
      class="black--text px-0 mb-2">
      Haz clic en “Enviar código” para recibir en tu
      correo electrónico un código con el que validaremos
      que eres propietario de la cuenta y podrás cambiar tu contraseña.
    </v-card-text>
    <v-card-actions
      class="px-0">
      <v-spacer v-if="options.align === 'right'"></v-spacer>
      <v-btn
        text
        class="grey--text px-10"
        :disabled="waiting"
        @click="cancel"
        v-if="options.cancel">
        Cancelar
      </v-btn>
      <v-btn
        class="brand-purple white--text px-10"
        :loading="waiting"
        @click="sendCode">
        Enviar código
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import loginController from '@/controllers/Login';

export default {
  name: 'SendCode',
  props: {
    email: {
      default: null,
    },
    exists: {
      default: false,
    },
    options: {
      default() {
        return {
          align: 'right',
          cancel: true,
        };
      },
    },
  },
  data() {
    return {
      waiting: false,
    };
  },
  methods: {
    cancel() {
      this.$emit('canceled');
    },
    sendCode() {
      this.waiting = true;
      loginController.generateCode(this.email, 'password_recover', true)
        .then(() => {
          this.$emit('generated');
        })
        .catch((e) => {
          this.$error(e);
        })
        .then(() => {
          this.waiting = false;
        });
    },
  },
};
</script>
